import { DialogContent as DialogContentMui, styled } from '@mui/material';

export const DialogContent = styled(DialogContentMui)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
